import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";

import ClientNavbar from "../components/ClientNavbar";
import Footer from "../components/Footer";
import api from "../services/api";

import "../styles/payment.css";

function PaymentPage() {
  const { id } = useParams();

  const [exam, setExam] = useState(null);

  const [formData, setFormData] = useState({
    email: "",
    phone_number: ""
  });

  useEffect(() => {
    fetchExam();
    // eslint-disable-next-line
  }, []);

  const fetchExam = async () => {
    try {
      const response = await api.get(`/exams/${id}`);
      setExam(response.data);
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Unable to load exam."
      });
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handlePayment = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.phone_number) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Please enter your email and phone number."
      });

      return;
    }

    const result = await Swal.fire({
      title: "Confirm Purchase",
      html: `
        <b>${exam.title}</b><br><br>
        Amount: <b>KES ${exam.price}</b><br><br>
        Continue to secure Paystack payment?
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Proceed",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#021658"
    });

    if (!result.isConfirmed) {
      return;
    }

    Swal.fire({
      title: "Initializing Payment...",
      text: "Please wait.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {

      const response = await api.post(
        "/payments/initialize",
        {
          exam_id: exam.id,
          email: formData.email,
          phone_number: formData.phone_number
        }
      );

      Swal.close();

      await Swal.fire({
        icon: "success",
        title: "Redirecting...",
        text: "Taking you to Paystack.",
        timer: 1200,
        showConfirmButton: false
      });

      window.location.href =
        response.data.authorization_url;

    } catch (error) {

      Swal.close();

      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Payment Failed",
        text:
          error.response?.data?.message ||
          "Unable to initialize payment."
      });

    }
  };

  if (!exam) {
    return (
      <>
        <ClientNavbar />
        <h2 style={{ textAlign: "center", marginTop: "100px" }}>
          Loading...
        </h2>
      </>
    );
  }

  return (
    <>
      <ClientNavbar />

      <div className="payment-page">

        <div className="payment-card">

          <h1>Secure Checkout</h1>

          <h2>{exam.title}</h2>

          <div className="payment-price">
            KES {exam.price}
          </div>

          <form onSubmit={handlePayment}>

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <input
              type="text"
              name="phone_number"
              placeholder="Phone Number"
              value={formData.phone_number}
              onChange={handleChange}
              required
            />

            <p className="secure-text">
              🔒 Secure payment powered by Paystack
            </p>

            <button type="submit">
              Proceed to Payment
            </button>

          </form>

        </div>

      </div>

      <Footer />
    </>
  );
}

export default PaymentPage;